import { render, staticRenderFns } from "./PasswordReminder.vue?vue&type=template&id=429cda33&scoped=true&"
import script from "./PasswordReminder.vue?vue&type=script&lang=ts&"
export * from "./PasswordReminder.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordReminder.vue?vue&type=style&index=0&id=429cda33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429cda33",
  null
  
)

export default component.exports